
import SettingsControls from './settings/SettingsControls';
import UserControls from './user/UserControls';

import './HeaderRightControls.scss'
import React from "react";
import {Box, useMediaQuery} from "@mui/material";
import {UserDto} from "../../../../../dtos";

const HeaderRightControls: React.FC = () => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);
    const isAccountTier1 = userDto?.accountTier === 1;
    const isXs = useMediaQuery(`(max-width:699px)`);

    return (
        <Box sx={{display: `flex`}} alignItems={`center`} justifyContent={`flex-end`}>
            {
                !isAccountTier1 && !isXs &&
                <SettingsControls />
            }
            <UserControls />
        </Box>
    )
}

export default HeaderRightControls;